import React, { useEffect, useState } from "react";
import CrmDashboardsub from "./CrmDashboardsub";
import SalesGraph from "./SalesGraph";
import TodoList from "./TodoList";
import Calander from "./Calander";
import { StoreOverview } from "./StoreOverview";
import RegisterNewUserModal from "./components/RegisterNewUserModal";
import axios from "axios";
import { path_url } from "../Config/config";
import { saveUserInfo, isUUID } from "../Utils/auth";

const DashboardV1 = () => {
  const [status, setStatus] = useState("");

  // api call for getting status of user and save complete user info
  useEffect(() => {
    const fetchData = async () => {
      const token = localStorage.getItem("accessToken");
      try {
        const response = await axios.get(`${path_url}/user`, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        });
        const data = response.data;
        const status = data.status;
        localStorage.setItem("status", status);
        setStatus(status);

        const rawId = isUUID(data.id) ? data.id : null;
        const rawAdminId = isUUID(data.adminid) ? data.adminid : rawId;
        if (rawId) {
          // Resolve name: use real name fields only — never email prefix
          const resolvedName = [
            data.name,
            data.userName,
            (data.firstName && data.lastName) ? `${data.firstName} ${data.lastName}`.trim() : null,
            (data.first_name && data.last_name) ? `${data.first_name} ${data.last_name}`.trim() : null,
          ].find(n => n && typeof n === "string" && n.trim() && !n.includes("@"));

          saveUserInfo({
            id: rawId,
            useradminid: rawAdminId,
            name: resolvedName || null,
            email: data.email || "",
            usertype: data.usertype || data.role || "USER",
          });
          // Update localStorage "name" key only when we have a real name
          if (resolvedName) localStorage.setItem("name", resolvedName);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, []);

  return (
    <>
      <div className="content-wrapper">
        <div className="content-header p-3">
          <div className="container-fluid">
            <div className="row mb-2">
              <div className="col-sm-6">
                <h1 className="m-0" style={{ fontSize: "1.8rem" }}>
                  Dashboard
                </h1>
              </div>
              <div className="col-sm-6">
                <ol className="breadcrumb float-sm-right">
                  <li
                    className="breadcrumb-item"
                    style={{ fontWeight: "600", fontSize: "1rem" }}
                  >
                    <a href="#">Home</a>
                  </li>
                  <li
                    className="breadcrumb-item"
                    style={{ fontWeight: "600", fontSize: "1rem" }}
                  >
                    Dashboard v1
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>
        <div className="content">
          <div className="col-12 d-flex justify-content-center">
            <div className="col-12 mt-2 d-flex row" style={{ width: "100%" }}>
              <div className="col-sm-6 col-md-6 col-lg-3">
                <CrmDashboardsub
                  index={0}
                  name="New Order"
                  value={0}
                  icon="HiOutlineShoppingBag"
                  class="bg-info"
                />
              </div>
              <div className="col-sm-6 col-lg-3">
                <CrmDashboardsub
                  index={1}
                  name="Bounce rate"
                  value={0}
                  icon="BiBarChart"
                  class="bg-success"
                />
              </div>
              <div className="col-sm-6 col-lg-3">
                <CrmDashboardsub
                  index={2}
                  name="User Registrations"
                  value={0}
                  icon="BiSolidUserPlus"
                  class="bg-warning"
                />
              </div>
              <div className="col-sm-6 col-lg-3">
                <CrmDashboardsub
                  index={3}
                  name="Unique Visitors"
                  value={0}
                  icon="IoMdPie"
                  class="bg-danger"
                />
              </div>
            </div>
          </div>
          <div className="d-flex w-100 justify-content-center">
            <div className="row d-flex mb-4 mr-4 ml-4 pl-1 pr-1 w-100">
              <div className="col-sm-6 mt-2 col-lg-6">
                <SalesGraph />
              </div>
              <div className="col-sm-6 mt-2 col-lg-6">
                <Calander />
              </div>
            </div>
          </div>
          <div className="d-flex w-100 justify-content-center">
            <div className="row d-flex mb-2 mr-4 ml-4 pl-1 pr-1 w-100">
              <div className="col-sm-6 col-lg-6">
                <TodoList />
              </div>
              <div className="col-sm-6 col-lg-6">
                <StoreOverview />
              </div>
            </div>
          </div>
        </div>
      </div>
      {status === "NEW" && <RegisterNewUserModal />}
    </>
  );
};

export default DashboardV1;